'use client';
import type { FooterProps } from './data';

import { usePathname } from 'next/navigation';

import LogoFooter from './LogoFooter';
import { ContactLia, TermsAndConditions, Tools } from './TitlesDesktop';
import TitlesPartMobile from './TitlesMobile';
import TopSection from './TopSection';

import { Box, Container } from '@/components';
import CurveSvgDesktop from '@/images/footer/curveFooterDesktop.svg';
import CurveSvgMobile from '@/images/footer/curveFooterMobile.svg';

const Footer: FooterProps = ({ socialNetworks, plans, ...props }) => {
  const pathname = usePathname();
  const isProductPage = pathname.startsWith('/products/');

  return (
    <Container
      pt={'80px'}
      paddingInline={0}
      pb={{ base: isProductPage ? '40px' : '0', lg: 0 }}
    >
      <Box display={{ base: 'none', xl: 'block' }}>
        <CurveSvgDesktop style={{ display: 'block' }} width="100%" />
      </Box>
      <Box display={{ base: 'block', xl: 'none' }}>
        <CurveSvgMobile style={{ display: 'block' }} width="100%" />
      </Box>
      <Box
        {...props}
        width="100%"
        overflow="hidden"
        backgroundColor="secondary.50"
        mt="-2px"
      >
        <footer>
          <Container mt={{ base: 0, xl: '50px' }}>
            <Box paddingInline="10px">
              <Box display={{ base: 'block', xl: 'none' }} mt="20px" mb="66px">
                <LogoFooter />
              </Box>
              <Box
                flexDir={'row'}
                mb={'36px'}
                display={{ base: 'none', xl: 'flex' }}
                justifyContent="space-between"
              >
                <TopSection socialNetworks={socialNetworks} />
                <ContactLia />
                <Tools />
                {plans && <TermsAndConditions plansFile={plans} />}
              </Box>
              <Box display={{ base: 'block', xl: 'none' }}>
                {plans && <TitlesPartMobile plansFile={plans} />}
                <Box my="60px">
                  <TopSection socialNetworks={socialNetworks} />
                </Box>
              </Box>
            </Box>
          </Container>
        </footer>
      </Box>
    </Container>
  );
};

export default Footer;
